export const Emit_Event_Common_Tool = {
    DELETE: "common-tool-delete",
    COPY: "common-tool-copy",
    EDIT: "common-tool-edit",
    RENDER_MODE_CHANGE: "render-mode-change",
    ACTIVE_MAJOR: "active-major",
    PICK_POINT: 'pick-point',
    UPDATE_STATUS: 'update-status',
}